/** @format */

import React, { Component } from 'react';
import { Menu, Button, Input, Icon, Form } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';

import './AdminPageToolbar.css';

@observer
class AdminPageToolbar extends Component {
  renderNewButton = () => {
    const { store } = this.props;

    return (
      <Menu.Item>
        <Button size="tiny" onClick={store.toggleEditModal} color="green">
          <Icon name="plus" />
          <span className="button-text">&nbsp;Nuovo</span>
        </Button>
      </Menu.Item>
    );
  };

  render() {
    const { store } = this.props;
    const menuKeys = Object.keys(store.filter.rules);
    return (
      <Menu className="request-toolbar" borderless size="tiny">
        <Menu.Menu position="left">
          {menuKeys.map(key => {
            return (
              <Menu.Item
                key={key}
                onClick={() => store.filterItems(key)}
                active={store.filter.status === key}
              >
                {store.filter.rules[key].label}
              </Menu.Item>
            );
          })}
        </Menu.Menu>
        <Menu.Menu position="right">
          <Menu.Item>
            <Form size="tiny">
              <Input
                size="small"
                value={store.search.value}
                className={
                  store.search.value ? 'search-input open' : 'search-input'
                }
                onChange={(e, input) => store.searchItem(input.value)}
                icon="search"
              />
            </Form>
          </Menu.Item>
          {this.renderNewButton()}
        </Menu.Menu>
      </Menu>
    );
  }
}

export default withRouter(AdminPageToolbar);
